
<div class="modal-header">
    <h1 class="logo float-left">
        North Carolina Judicial Branch
    </h1>
</div>
<div class="modal-body container-fluid">
  <div *ngIf="isPAT">
      No activity has been detected in 10 minutes. If you do nothing, this session will reset in {{secondsLeft}} seconds.
      <button class="btn btn-primary" (click)="keepSessionAlive()">Keep my session alive</button>
      <button class="btn btn-primary" (click)="clearHistory()">I'm done</button>
  </div>
  <div *ngIf="!isPAT" class="text-center">
    <h4>No activity has been detected in 10 minutes. If you do nothing, you will be logged out in {{secondsLeft}} seconds.</h4>
    <button class="btn btn-primary center-block" (click)="keepSessionAlive()">Stay logged in</button>
  </div>
</div>



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/session-timeout-warning/session-timeout-warning.component.html